import axios from "../../utils/axios";

export const getItems = async () => {
  const res = await axios.get("/transactions");
  return res.data;
};
export const addItem = async (data) => {
  const res = await axios.post("/transactions", data);
  return res.data;
};

export const editItem = async (id, data) => {
  const res = await axios.put(`/transactions/${id}`, data);
  return res.data;
};
export const deleteItem = async (id) => {
  const res = await axios.delete(`/transactions/${id}`);
  return res.data;
};
